// components/BlogSlider.jsx
import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules';
import { getImageUrlWithSas } from '../../services/SAS';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import classes from './styles/blogSlider.module.css';

const BlogSlider = ({ blogs }) => {
  const [imageUrls, setImageUrls] = useState({});

  // Fetch image URLs for all blogs
  useEffect(() => {
    const fetchAllImages = async () => {
      const urls = {};
      for (const blog of blogs) {
        if (blog.featured_image_url) {
          try {
            const response = await getImageUrlWithSas(blog.featured_image_url);
            urls[blog._id] = response.data.url;
          } catch (error) {
            console.error("Error fetching image URL:", error);
            urls[blog._id] = 'https://www.fetchjobs.co/static/media/fetchjobLogo.aa2faf0113cf3ef779e0.png';
          }
        } else {
          urls[blog._id] = 'https://www.fetchjobs.co/static/media/fetchjobLogo.aa2faf0113cf3ef779e0.png';
        }
      }
      setImageUrls(urls);
    };

    if (blogs.length > 0) {
      fetchAllImages();
    }
  }, [blogs]);

  if (!blogs.length) return null;

  return (
    <div className={classes.sliderContainer}>
      <Swiper
        modules={[Autoplay, Navigation, Pagination, EffectFade]}
        effect="fade"
        spaceBetween={0}
        slidesPerView={1}
        navigation={{
          nextEl: `.${classes.customNext}`,
          prevEl: `.${classes.customPrev}`,
        }}
        pagination={{
          clickable: true,
          el: `.${classes.customPagination}`,
          bulletClass: classes.customBullet,
          bulletActiveClass: classes.customBulletActive,
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        loop={blogs.length > 1}
        speed={800}
        className={classes.blogSwiper}
      >
        {blogs.map((blog) => (
          <SwiperSlide key={blog._id} className={classes.swiperSlide}>
            <div className={classes.slideImage}>
              <img 
                src={imageUrls[blog._id] || 'https://www.fetchjobs.co/static/media/fetchjobLogo.aa2faf0113cf3ef779e0.png'} 
                alt={blog.title}
              />
              <div className={classes.slideOverlay}>
                <div className={classes.slideContent}>
                  <span className={classes.slideCategory}>{blog.category || 'Article'}</span>
                  <h2 className={classes.slideTitle}>
                    <a href={`/blog/${blog.slug}`}>{blog.title}</a>
                  </h2>
                  <p className={classes.slideExcerpt}>
                    {blog.excerpt && blog.excerpt !== 'string' 
                      ? blog.excerpt.substring(0, 120) 
                      : (blog.content?.substring(0, 120) || '')}...
                  </p>
                  <div className={classes.slideMeta}>
                    <span>By {blog.author && blog.author !== 'string' ? blog.author : 'Admin'}</span>
                    <span>{new Date(blog.createdAt).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Buttons */}
      {blogs.length > 1 && (
        <>
          <button className={`${classes.sliderBtn} ${classes.customPrev}`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button className={`${classes.sliderBtn} ${classes.customNext}`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          
          <div className={classes.customPagination}></div>
        </>
      )}
    </div>
  );
};

export default BlogSlider;